<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Lead" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
					<button
						type="button"
						class="btn btn-success btn-with-shadow"
						@click="openExportModal"
					>
						Export Excel
					</button>
					<!-- <button
						type="button"
						class="btn btn-primary btn-with-shadow"
						data-toggle="modal"
						@click="openAddEditModal"
					>
						{{ $t("add") }}
					</button> -->
				</div>
			</div>
		</div>

		<app-table :id="tableId" :options="options" @action="getListAction" />

		<!-- <app-add-modal
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/> -->

		<lead-list-form
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :form-id="formId"
            :row-data="rowData"
            :selected-url="selectedUrl"
            @close-modal="closeAddEditModal"
        />

		<app-delete-modal
			v-if="deleteConfirmationModalActive"
			:preloader="deleteLoader"
			modal-id="demo-delete"
			@confirmed="confirmed"
			@cancelled="cancelled"
		/>

		<export-excel-modal
			v-if="exportModalActive"
			@close-modal="closeExportModal"
			@export="exportExcel"
		/>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import { Schema } from "./Schema";
import { urlGenerator } from "../../../../../Helpers/AxiosHelper";
import { LEAD } from "../../../../../Config/ApiUrl";
import ExportExcelModal from "./ExportExcelModal.vue";

export default {
	extends: CoreLibrary,
	name: "LeadListTable",
	mixins: [Schema],
	created() {
		this.options.columns = [...this.tableColumns, this.actionObj];
	},
	data() {
		return {
			exportModalActive: false,
		}
	},
    components: {
        ExportExcelModal
    },
	methods: {
		openExportModal() {
			this.exportModalActive = true;
		},
	
		closeExportModal() {
			$("#export-excel-modal").modal("hide");
			this.exportModalActive = false;
		},
		/**
		 * for open add edit modal
		 */
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},
			
		exportExcel(filter) {
			this.closeExportModal();

			const url =
				`/transaction/lead/export?` +
				`start_date=${filter.start_date}` +
				`&end_date=${filter.end_date}`;

			window.open(url, "_blank");
		},

		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			$("#lead-list-form").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;

			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				this.selectedUrl = `${LEAD}/${rowData.id}`;
				this.openAddEditModal();
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			let url = `/transaction/lead/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},

		/**
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
</script>
<style scoped>
	::v-deep(.bg-green-row) {
		background-color: #ddf9e4 !important
	}
	::v-deep(.fn-green-row) {
		color: #087b08;
		font-weight: 600;
	}
	::v-deep(.fn-red-row) {
		color: red;
		font-weight: 600;
	}
    ::v-deep .custom-scrollbar{
        padding-top: 0 !important;
    }

    ::v-deep .datatable-th{
        z-index: 1;
        position: relative;
    }
	::v-deep .custom-scrollbar{
		max-height: 70vh;
	}
</style>
